import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c3bbc824&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3bbc824",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3bbc824')) {
      api.createRecord('c3bbc824', component.options)
    } else {
      api.reload('c3bbc824', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c3bbc824&scoped=true&", function () {
      api.rerender('c3bbc824', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/page_islide_landing/components/PaidModal/index.vue"
export default component.exports